import type { RichTextDto } from "@/spz-api/model";
import { create } from "zustand";

interface CommentEditingState {
  editingCommentId: string | null;
  editedContent: RichTextDto;
  setEditingComment: (commentId: string | null, content: RichTextDto) => void;
  resetEditing: () => void;
  updateContent: (content: RichTextDto) => void;
}

export const useCommentEditingStore = create<CommentEditingState>((set) => ({
  editingCommentId: null,
  editedContent: {} as RichTextDto,
  setEditingComment: (commentId, content) =>
    set({ editingCommentId: commentId, editedContent: content }),
  resetEditing: () => set({ editingCommentId: null, editedContent: undefined }),
  updateContent: (content) => set({ editedContent: content }),
}));
